import { render, staticRenderFns } from "./ContactTagsPreview.vue?vue&type=template&id=25a30d50&"
import script from "./ContactTagsPreview.vue?vue&type=script&lang=js&"
export * from "./ContactTagsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports